import React from "react";
import { useT } from "../i18n/LanguageContext";

const LOGOS = [
  { src: "/assets/clients/logos/telkom.png", alt: "Telkom" },
  { src: "/assets/clients/logos/cellc.png", alt: "Cell C" },
  { src: "/assets/clients/logos/mtn.png", alt: "MTN" },
  { src: "/assets/clients/logos/metropolitan.png", alt: "Metropolitan" },
  { src: "/assets/clients/logos/oldmutual.png", alt: "Old Mutual" },
  { src: "/assets/clients/logos/sanlam.png", alt: "Sanlam" },
  { src: "/assets/clients/logos/fnb.png", alt: "First National Bank" },
  { src: "/assets/clients/logos/absa.png", alt: "ABSA" },
  { src: "/assets/clients/logos/unisa.png", alt: "UNISA" },
  { src: "/assets/clients/logos/upe.png", alt: "University of Port Elizabeth" },
];

const SECTORS_KEYS = [
  { key: "clients.sector.telecom", clients: ["Telkom", "Cell C", "MTN", "Post Office", "Department of Communications"] },
  { key: "clients.sector.banking", clients: ["First National Bank", "ABSA", "Old Mutual", "Sanlam", "Metropolitan", "Medscheme", "Industrial Development Corporation"] },
  { key: "clients.sector.gov", clients: ["SARS — South African Revenue Service", "Department of Correctional Services", "Department of Justice", "Department of Trade and Industry", "Department of Labour", "Department of Transport", "Department of Defence (SANDF / SAAF / SA Navy)", "SA Police Service", "Road Traffic Management Corporation", "National Home Builders Regulation Council", "Independent Electoral Commission (IEC)", "Lesotho Revenue Authority", "National Department of Water Affairs", "Gauteng Gambling Board"] },
  { key: "clients.sector.health", clients: ["Department of Health (National)", "Health Professions Council of South Africa", "Limpopo Department of Health & Social Development"] },
  { key: "clients.sector.education", clients: ["UNISA — University of South Africa", "University of Port Elizabeth (UPE)"] },
  { key: "clients.sector.transport", clients: ["Transnet Freight Rail", "Bombardier", "Toshiba", "UCW", "CSR", "CNR", "China South Railways"] },
  { key: "clients.sector.electoral", clients: ["Nigerian INEC", "Tanzania (UNDP)", "Electoral Commission of Zambia", "Malawi Electoral Commission", "Rwanda Elections", "Swaziland Elections", "Guinea-Bissau Elections", "Liberia Elections", "DRC Elections", "Republic of Guinea Elections"] },
];

export default function ClientsBand() {
  const { t } = useT();
  const track = [...LOGOS, ...LOGOS]; // duplicated for seamless loop

  return (
    <section className="relative border-b border-white/10 py-20 md:py-28" data-testid="clients-band">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16">
        <div className="flex items-center justify-between gap-6">
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-brand-textDim">
            06 · {t("clients.tag")}
          </span>
          <div className="hidden h-px flex-1 bg-white/10 md:block" />
        </div>
        <h3 className="mt-5 max-w-3xl font-heading text-2xl tracking-tight text-white sm:text-3xl">
          {t("clients.title")}
        </h3>
      </div>

      {/* Marquee */}
      <div
        className="relative mt-12 overflow-hidden border-y border-white/10 bg-white py-8"
        data-testid="clients-marquee"
        style={{
          maskImage: "linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent)",
          WebkitMaskImage: "linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent)",
        }}
      >
        <div className="marquee-track items-center gap-16 px-6">
          {track.map((logo, i) => (
            <img
              key={`${logo.alt}-${i}`}
              src={logo.src}
              alt={logo.alt}
              className="h-12 w-auto shrink-0 object-contain opacity-80 transition-opacity hover:opacity-100 sm:h-14"
              loading="lazy"
              data-testid={i < LOGOS.length ? `client-logo-${logo.alt.toLowerCase().replace(/[^a-z0-9]+/g, "-")}` : undefined}
            />
          ))}
        </div>
      </div>

      {/* Sector list */}
      <div className="mx-auto mt-16 max-w-[1440px] px-6 md:px-12 lg:px-16">
        <div className="grid gap-px border border-white/10 bg-white/5 md:grid-cols-2 lg:grid-cols-3">
          {SECTORS_KEYS.map((s, i) => (
            <div key={s.key} className="bg-brand-bg p-6" data-testid={`clients-sector-${i}`}>
              <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-brand-red">
                {String(i + 1).padStart(2, "0")} · {t(s.key)}
              </p>
              <ul className="mt-4 space-y-2 text-sm text-white/85">
                {s.clients.map((c) => (
                  <li key={c} className="border-b border-white/5 pb-1.5">
                    {c}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
